export default {
  base: {
    bg: 'grey-0',
    color: 'primary',
    name: {
      fontSize: ['xxxs', 'xxs', 'base'],
      fontWeight: '700'
    },
    subtitle: {
      color: 'grey-60',
      fontSize: 'xxxs'
    },
    hover: {
      bg: 'grey-05'
    },
    focus: {
      bg: 'grey-0',
      outline: '2px solid',
      outlineColor: 'orange'
    }
  }
};